<template>
  <!--Welcome Message-->
  <div>
    <div class="welcome-msg">
      <h2>Welcome Message</h2>
      <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
      <button class="add-page-btn">
        <i class="fa fa-plus"></i>
        <span>Create new page</span>
      </button>
    </div>
    <page-component></page-component>
    <app-card-component></app-card-component>
  </div>
</template>

<script>
import PageComponent from "./Page.vue";
import AppCardComponent from "./AppCard.vue";

export default {
  name: "EditModeBoard",
  components: {
    PageComponent,
    AppCardComponent
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.welcome-msg {
  text-align: center;
  max-width: 800px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
}
</style>
